// extracted by mini-css-extract-plugin
export var addButton = "_jt-0";
export var border = "_jt-8";
export var check = "_jt-h";
export var danger = "_jt-6";
export var dropdownContainer = "_jt-1";
export var editModalBody = "_jt-j";
export var footerContainer = "_jt-i";
export var fullWidth = "_jt-a";
export var hide = "_jt-9";
export var icon = "_jt-3";
export var input = "_jt-7";
export var inputFlex = "_jt-b";
export var inputWrapper = "_jt-c";
export var manualFocus = "_jt-5";
export var optionButton = "_jt-4";
export var pillWrapper = "_jt-e";
export var pointer = "_jt-2";
export var showOverflow = "_jt-f";
export var tagsFlex = "_jt-d";
export var xButton = "_jt-g";